<template>
    <button class="icon-btn copy-link" :class="props.classBtn" @click.prevent="copy">
        <IconDef name="copy-link"/>
    </button>
</template>

<script setup>
import IconDef from "~/components/UI/IconDef.vue"

const props = defineProps({
    classBtn: {
        type: String,
        default: ''
    },
});

function copy() {
    navigator.clipboard.writeText(location.href)
        .then(() => alert("Ссылка скопирована"));
}
</script>

